<template>
  <ValidationProvider
    name="application_type"
    ref="provider"
    rules="required"
    v-slot="{ errors, validate }"
  >
    <v-select
      v-model="application_type"
      :items="applicationTypes"
      item-value="id"
      item-text="name"
      label="Образовательный уровень и форма обучения"
      @change="validate"
      :error-messages="errors"
      max-height="auto"
      :loading="loading"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-text="item.education_level_name"></v-list-item-title>
          <v-list-item-subtitle v-text="item.form_name"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-select>
  </ValidationProvider>
</template>

<script>
  import {mapGetters} from "vuex";
  import {extend, localize, ValidationProvider} from "vee-validate";
  import {required} from "vee-validate/dist/rules";

  export default {
    name: "ApplicationTypeSelect",
    components: {
      ValidationProvider
    },
    props: ["applicationTypes"],
    data() {
      return {
        isSuccess: false,
      }
    },
    watch: {
      applicationTypes() {
        this.$refs.provider.reset()
      }
    },
    computed: {
      ...mapGetters("application", ["application"]),
      ...mapGetters("application_type", ["loading"]),
      application_type: {
        get() {
          return this.application.application_type
        },
        set(value) {
          this.$store.commit("application/CHANGE_APPLICATION", {application_type_id: value})
          this.$store.dispatch("application/updateApplication")
        }
      },
    },
    methods: {
      async submit() {
        const {valid} = await this.$refs.provider.validate(this.application_type);
        if (valid) {
          this.isSuccess = true
        }
      }
    }
  }

  localize({
    ru: {
      names: {
        application_type: " "
      }
    }
  });

  extend("required", {
    ...required
  });
</script>
